import ExpandablePanel from './ExpandablePanel.view';

export default ExpandablePanel;
